import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../preact-components/modal'
import Checkbox from '../../ui-components/Checkbox'
import { Model } from '../../../preact-components/table/types'
import Button from '@insided/control/uikit/Button'

interface Props {
  columns: Model[]
  showModal: boolean
  onApply: () => void
  onClose: () => void
  onResetToDefault: () => void
  toggleColumn: (accessor: string, checked: boolean) => void
}

const SelectColumnsModal = (props: Props) => {
  const { columns, showModal, onApply, onClose, onResetToDefault, toggleColumn } = props

  function formatColumns() {
    return columns.map((column: Model, index: number) => {
      return (
        <div className='overview-select-columns-modal__column' key={index}>
          <Checkbox
            label=''
            onUpdate={(checked: boolean) => {
              toggleColumn(column.accessor as string, checked)
            }}
            qaClasses='qa-select-all'
            checked={!column.isHidden}
            disabled={column.isFixed}
          />
          {column.header} {column.label && <span>{column.label}</span>}
        </div>
      )
    })
  }

  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title='Custom table view' onClose={onClose} />
      <ModalBody>{formatColumns()}</ModalBody>
      <ModalFooter>
        <Button
          title='Apply'
          variant='brand'
          onClick={onApply}
          className='qa-apply-columns'
          size='medium'
        />
        <Button title='Cancel' onClick={onClose} size='medium' />
        <Button
          title='Reset to default'
          onClick={onResetToDefault}
          className='qa-reset-columns'
          size='medium'
        />
      </ModalFooter>
    </Modal>
  )
}

export default SelectColumnsModal
